export const auth = {
  login: {
    title: 'Welcome back',
    subtitle: 'Sign in to continue',
    email: 'Email address',
    emailPlaceholder: 'john@example.com',
    password: 'Password',
    passwordPlaceholder: 'Your password',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot password?',
    loginButton: 'Sign in',
    signingIn: 'Signing in...',
    orLoginWith: 'Or sign in with',
    google: 'Google',
    apple: 'Apple',
    noAccount: 'No account yet?',
    registerNow: 'Register now',
    alreadyRegistered: 'Already registered?',
    signIn: 'Sign in',
    loginSuccess: 'Welcome back!',
    otpSent: 'Verification code sent to your email.',
  },

  register: {
    title: 'Create your account',
    subtitle: 'Start your journey to a healthier life',
    formTitle: 'Registration form',
    fullName: 'Full name',
    namePlaceholder: 'John Doe',
    email: 'Email address',
    emailPlaceholder: 'john@example.com',
    password: 'Password',
    passwordPlaceholder: 'At least 8 characters',
    confirmPassword: 'Confirm password',
    confirmPasswordPlaceholder: 'Repeat password',
    acceptTerms: 'I accept the',
    terms: 'Terms and Conditions',
    and: 'and the',
    privacy: 'Privacy Policy',
    registerButton: 'Register now',
    creatingAccount: 'Creating account...',
    haveAccount: 'Already have an account?',
    loginHere: 'Sign in here',
    alreadyRegistered: 'Already registered?',
    selectedPlan: 'Selected plan',
    monthly: 'Monthly',
    yearly: 'Yearly',
    yearlyDiscount: '-20%',
    yearlyDiscountText: '20% discount on yearly payment',
    perMonth: 'per month',
    perYear: 'per year',
    youSave: 'You save {amount}',
    securityTitle: 'Safe & Secure',
    securityText: 'Your data is safe with us. We use state-of-the-art encryption and do not store payment information.',
    referralBannerTitle: 'You were invited by a friend!',
    referralBannerText: 'You will receive 10% off your first month when you subscribe.',
  },

  plans: {
    basic: {
      name: 'Basic Plan',
      features: [
        '1× complete 30-day plan',
        'Simple meal descriptions',
        'Calories & ingredients per day',
        'Considers allergies & preferences',
        'No modifications possible',
        'No detailed recipes',
        'No PDF export'
      ]
    },
    vip: {
      name: 'VIP Plan',
      features: [
        'Unlimited 30-day plans',
        'Changeable & adjustable anytime',
        'Detailed step-by-step recipes',
        'Complete shopping list & recipe list',
        'PDF export for all plans',
        'Dashboard with progress',
        'Daily motivational emails',
        '24/7 NutriBot chat assistant'
      ]
    }
  },

  benefits: {
    secure: 'Safe & Secure',
    access247: '24/7 Access',
    support: 'Support',
  },

  validation: {
    emailRequired: 'Please enter your email address',
    emailInvalid: 'Please enter a valid email address',
    passwordRequired: 'Please enter your password',
  },

  errors: {
    // Generic
    generic: 'Something went wrong. Please try again.',
    networkError: 'Network error. Please check your connection.',

    // Name
    nameRequired: 'Full name is required',
    nameTooShort: 'Name must be at least 2 characters',

    // Email
    emailRequired: 'Email address is required',
    emailInvalid: 'Please enter a valid email address',
    emailAlreadyExists: 'An account with this email already exists',

    // Password
    passwordRequired: 'Password is required',
    passwordTooShort: 'Password must be at least 8 characters',
    passwordWeak: 'Password must contain at least one uppercase letter and one number',
    passwordMismatch: 'Passwords do not match',

    // Terms
    termsRequired: 'You must accept the terms and conditions',

    // Login
    invalidCredentials: 'Invalid email or password',
    tooManyRequests: 'Too many attempts. Please try again later.',
    accountDisabled: 'This account has been disabled. Please contact support.',

    // Device / OTP
    deviceFingerprintNotReady: 'Device identification not ready. Please try again.',
    invalidOTPLink: 'Invalid verification link. Please log in again.',
    otpInvalid: 'Please enter a valid 6-digit code',
    otpIncorrect: 'Incorrect verification code. Please try again.',
    otpExpired: 'The verification code has expired. Please request a new one.',
    otpMaxAttempts: 'Maximum attempts exceeded. Please request a new code.',
    resendFailed: 'Failed to resend code. Please try again.',

    // Password Reset
    invalidResetLink: 'Invalid reset link',
    resetLinkExpired: 'This reset link has expired. Please request a new one.',
    resetLinkUsed: 'This reset link has already been used. Please request a new one.',
    resetFailed: 'Password reset failed. Please try again.',
    tooManyResetRequests: 'Too many reset requests. Please try again in a few minutes.',

    otpSendFailed: 'Account created but failed to send confirmation email. Please use the resend option.',
  },

  otp: {
    title: 'Verify Your Device',
    subtitle: 'We sent a 6-digit code to',
    verifyingDevice: 'Verifying device',
    verifyButton: 'Verify Device',
    verifying: 'Verifying...',
    didntReceive: "Didn't receive the code?",
    resendButton: 'Resend Code',
    resendIn: 'Resend in {{seconds}}s',
    sending: 'Sending...',
    checkSpam: "Check your spam folder if you don't see the email",
    expiresIn: 'The code expires in 5 minutes',
    attemptsLeft: '{{count}} attempts remaining',
    oneAttemptLeft: '1 attempt remaining',
    verificationSuccess: 'Device verified successfully.',
  },

  // ---------------------------------------------------------------------------
  // FORGOT PASSWORD
  // ---------------------------------------------------------------------------
  forgotPassword: {
    title: 'Reset Password',
    subtitle: "Enter your email and we'll send you a reset link",
    emailLabel: 'Email Address',
    emailPlaceholder: 'your@email.com',
    submitButton: 'Send Reset Link',
    sending: 'Sending...',
    backToLogin: 'Back to Login',
    securityNote: 'Reset links expire after 1 hour and can only be used once',
    checkEmail: 'Check Your Email',
    successMessage: 'If an account exists with this email, you will receive password reset instructions shortly.',
    didntReceive: "Didn't receive the email?",
    hint1: 'Check your spam or junk folder',
    hint2: 'The email may take a few minutes to arrive',
    hint3: 'Make sure you entered the correct email address',
    tryDifferentEmail: 'Try a Different Email',
  },

  // ---------------------------------------------------------------------------
  // RESET PASSWORD
  // ---------------------------------------------------------------------------
  resetPassword: {
    title: 'New Password',
    subtitle: 'Create a strong password for your account',
    newPasswordLabel: 'New Password',
    newPasswordPlaceholder: 'Enter new password',
    confirmPasswordLabel: 'Confirm Password',
    confirmPasswordPlaceholder: 'Re-enter new password',
    submitButton: 'Reset Password',
    resetting: 'Resetting...',
    backToLogin: 'Back to Login',
    validating: 'Validating reset link...',
    securityNote: 'After resetting, you will be signed out from all other devices for your security',
    invalidToken: 'Link Expired',
    invalidTokenMessage: 'This password reset link is invalid or has already expired.',
    requestNewLink: 'Request New Link',
    reqLength: 'At least 8 characters',
    reqUppercase: 'One uppercase letter',
    reqNumber: 'One number',
    reqMatch: 'Passwords match',
    strengthWeak: 'Weak',
    strengthMedium: 'Medium',
    strengthStrong: 'Strong',
  },
  // ---------------------------------------------------------------------------
  // PASSWORD RESET (toast/status messages)
  // ---------------------------------------------------------------------------
  passwordReset: {
    emailSent: 'If an account exists with this email, you will receive reset instructions shortly.',
    resetSuccess: 'Password reset successfully. You can now sign in with your new password.',
  },

  verifyEmail: {
    title: 'Confirm Your Email',
    subtitle: 'We sent a 6-digit confirmation code to',
    confirmButton: 'Confirm Email',
    expiresIn: 'Code expires in 10 minutes',
  },
};